import React, { useEffect, useState } from "react";
import "./styles/testimonialSection.css";
//Components
import CardTestimonial from "../../components/cardTestiomonial/CardTestimonial";
//Assets

const Testiomonials = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(1);

  const dataTestiomonial = [
    {
      comment:
        "Me permite seguir mis entrenamientos acompañado de expertos, enfocando a mis metas personales y profesionales.",
      nameUser: "Juan Jesús Portillo",
      urlPhoto: "",
      score: 5,
      usrId: 1,
    },
    {
      comment:
        "Me ayudaron en la recuperación de una lesió, en todo momento acompañaron mi progeso y motivaron a continuar entrenando.",
      nameUser: "Aurelio",
      urlPhoto: "",
      score: 5,
      usrId: 2,
    },
    {
      comment:
        "Durante mi preparacion para mi primer maratón de 5km, me sentí acompañado en todo este proceso ",
      nameUser: "Raymundo Navarro",
      urlPhoto: "",
      score: 5,
      usrId: 3,
    },
  ];

  useEffect(() => {
    const updateItemsPerPage = () => {
      const width = window.innerWidth;
      if (width >= 1024) {
        setItemsPerPage(3);
      } else if (width >= 768) {
        setItemsPerPage(2);
      } else {
        setItemsPerPage(1);
      }
    };

    updateItemsPerPage();

    window.addEventListener("resize", updateItemsPerPage);

    // Eliminar el listener cuando se desmonte el componente
    return () => window.removeEventListener("resize", updateItemsPerPage);
  }, []);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = dataTestiomonial.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(dataTestiomonial.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }
  // console.log(pageNumbers);

  return (
    <section className="container bg-black  wrap-testimonial">
      <section className="text-info d-flex flex-column align-items-center">
        <h3 className="d-flex justify-content-center">Nuestros clientes</h3>
        <p className="d-flex justify-content-center">
          Nuestros clientes satisfechos comparten sus historias de éxito y
          experiencias en su viaje hacia la salud y bienestar.
        </p>
      </section>
      <section className="subWrap-cards">
        <div className="card-container">
          {currentItems.map((testimonial) => (
            <CardTestimonial
              key={testimonial.usrId}
              dataTestiomonial={testimonial}
            />
          ))}
        </div>
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="btn btn-primary"
          >
            &lt;
          </button>
          {pageNumbers.map((number) => (
            <button
              key={number}
              onClick={() => paginate(number)}
              className={`${number === currentPage ? "active" : ""} btn-circle`}
            ></button>
          ))}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === pageNumbers.length}
            className="btn btn-primary"
          >
            &gt;
          </button>
        </div>
      </section>
    </section>
  );
};

export default Testiomonials;
